import { fromJS } from 'immutable'
import {
  REPORT_YEAR_OF_SERVICE_GET_REQUEST,
  REPORT_YEAR_OF_SERVICE_GET_SUCCESS,
  REPORT_YEAR_OF_SERVICE_GET_FAILURE,
  REPORT_YEAR_OF_SERVICE_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case REPORT_YEAR_OF_SERVICE_GET_REQUEST:
      return state
        .set('isFetching', true)
    case REPORT_YEAR_OF_SERVICE_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('yearOfService', fromJS(action.payload.yearOfService))
    case REPORT_YEAR_OF_SERVICE_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case REPORT_YEAR_OF_SERVICE_GET_RESET:
      return state
        .delete('yearOfService')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/report/report-year-of-service-get-reducer.js